import { render, staticRenderFns } from "./ipt-text.vue?vue&type=template&id=09c79c5d&scoped=true&"
import script from "./ipt-text.vue?vue&type=script&lang=ts&"
export * from "./ipt-text.vue?vue&type=script&lang=ts&"
import style0 from "./ipt-text.vue?vue&type=style&index=0&id=09c79c5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c79c5d",
  null
  
)

export default component.exports